import React from 'react'
import { func } from 'prop-types'

import CustomSkinModal from 'components/buy/CustomSkinModal'

const BuySkins = ({ setSkinsModaVisible, handleAddSkins }) => {
  return (
    <CustomSkinModal
      addToCartOnly
      handleSkinQuantityChange={handleAddSkins}
      close={() => {
        setSkinsModaVisible(false)
      }}
      buyFlow
    />
  )
}

BuySkins.propTypes = {
  setSkinsModaVisible: func,
  handleAddSkins: func
}

export default BuySkins
